import { useContext, useEffect, useState } from "react";
import { toDateTimeString } from "../date_utils";
import { TableDef } from "../table_def";
import { Context } from "../context";
import * as FC from "@fluentui/react-components";

export const DefDefectionDef = new TableDef("def_defection", {
    seq: {
        label: "编号",
        display: (item) => item.seq?.toString(),
    },
    name: {
        label: "名称",
    },
    color: {
        label: "颜色",
    },
    description: {
        label: "备注",
    },
    updated_at: {
        label: "更新时间",
        display: (item) => toDateTimeString(item.updated_at),
    },
});

const def_defection_searchable_columns = [
    "name",
    // "description"
];
export const listDefDefection = async (apiClient, filter) => {
    try {
        const items = await apiClient.getDefDefections();
        
        // Apply client-side filtering if needed
        if (filter && filter.trim()) {
            const filterLower = filter.toLowerCase();
            return items.filter(item => 
                def_defection_searchable_columns.some(column => {
                    return item[column]?.toString().toLowerCase().includes(filterLower);
                })
            );
        }
        
        return items;
    } catch (error) {
        console.error("Failed to load def defections:", error);
        if (error.message && error.message.includes('404')) {
            console.warn("DefDefection API not implemented. Using empty list.");
        }
        return [];
    }
};

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const DefDefectionDropdown = (props) => {
    const { apiClient } = useContext(Context);
    const [items, setItems] = useState([]);
    const loadItems = async () => {
        try {
            let items = await listDefDefection(apiClient, null);
            console.log("def_defections:", items);
            items = items.map((item) => ({ value: item.id, text: item.name }));
            setItems([{ value: "", text: "全部" }, ...items]);
        } catch (error) {
            console.error("Failed to load def defections:", error);
            setItems([{ value: "", text: "全部" }]);
        }
    };
    useEffect(() => {
        if (!apiClient) {
            return;
        }
        loadItems();
    }, [apiClient]);
    return (
        <FC.Dropdown {...props}>
            {items.map((item) => (
                <FC.Option key={item.value} value={item.value}>
                    {item.text}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};
